<script setup>
import { ref, onMounted } from 'vue'

const DISMISS_KEY = 'krate.banner.dismissed'

const visible = ref(true)

onMounted(() => {
  if (typeof sessionStorage === 'undefined') return
  try {
    if (sessionStorage.getItem(DISMISS_KEY) === '1') {
      visible.value = false
    }
  } catch {}
})

function dismiss() {
  visible.value = false
  if (typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(DISMISS_KEY, '1')
  } catch {}
}
</script>

<template>
  <div v-if="visible" class="platform-banner" role="status">
    <span class="platform-banner-text">
      <span class="platform-banner-warn" aria-hidden="true">⚠</span>
      Beta (Apple Silicon only)
      <router-link to="/roadmap" class="platform-banner-link">See roadmap →</router-link>
    </span>
    <button
      type="button"
      class="platform-banner-close"
      aria-label="Dismiss banner"
      @click="dismiss"
    >×</button>
  </div>
</template>

<style scoped>
.platform-banner {
  position: relative;
  z-index: 60;
  background: #fef3c7;
  border-bottom: 1px solid #fcd34d;
  color: #92400e;
  padding: 0.85rem 1.25rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.4;
}
.platform-banner-text {
  display: inline-block;
}
.platform-banner-warn {
  margin-right: 0.4rem;
}
.platform-banner-link {
  color: var(--color-krate-blue-700);
  text-decoration: underline;
  margin-left: 0.4rem;
  font-weight: 500;
}
.platform-banner-link:hover {
  color: var(--color-krate-blue-900);
}
.platform-banner-close {
  position: absolute;
  top: 50%;
  right: 0.6rem;
  transform: translateY(-50%);
  background: transparent;
  color: rgba(146, 64, 14, 0.65);
  border: none;
  font-size: 1.25rem;
  line-height: 1;
  padding: 0.35rem 0.55rem;
  border-radius: var(--radius-md, 6px);
  cursor: pointer;
}
.platform-banner-close:hover {
  color: #92400e;
  background: rgba(146, 64, 14, 0.08);
}
</style>
